module.exports = __webpack_public_path__ + "static/media/icon-trash.59f0d2ad.svg";